import React, { useState, createContext, useContext } from "react";

// context for managing registration data in Register screen
const initalState = {
    data: [],
};

const CenterPanelContext = createContext(initalState);

export const CenterPanelProvider = ({ children }) => {
  const [data, setData] = useState({}); // Stores questions and answers
  const [marketOverviewData, setMarketOverviewData] = useState({}); // Stores market overview data
  const [section2Data, setSection2Data] = useState({}); // Stores section 2 data
  const [section3Data, setSection3Data] = useState({}); // Stores section 3 data
  const [section4Data, setSection4Data] = useState({}); // Stores section 4 data
  return (
    <CenterPanelContext.Provider
      value={{
        data, setData, marketOverviewData, setMarketOverviewData,
        section2Data, setSection2Data,
        section3Data, setSection3Data,
        section4Data, setSection4Data,
      }}
    >
      {/* {renderComponent()} */}
      {children}
    </CenterPanelContext.Provider>
  );
};

export const useCenterPanelContext = () => useContext(CenterPanelContext);
